import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "n-file-message__file-size" }

import { computed } from 'vue';
import moment from 'moment';
import tinycolor2 from 'tinycolor2';
import NIcon from '../../brand/icon/icon.vue';
import NTooltip from '../../control/tooltip/tooltip.vue';
import NAvatar from '../avatar/avatar.vue';
import { Message, FileMessage } from './message';
import { MessageStatus } from './messageStatus';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'file-message',
  props: {
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  message: {
    type: Object as PropType<FileMessage>,
    required: true,
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  tooltipPosition: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
},
  setup(__props) {

const props = __props;

function getMessageTimestamp(timestamp: Date): string {
  return moment(timestamp).format('HH:mm');
}

function shouldShowAlertIcon(m: Message) {
  return m.status === MessageStatus.DeliveryFailed;
}

function isRead(m: Message) {
  return m.status === MessageStatus.Read;
}

function shouldShowTickIcon(m: Message) {
  switch (m.status) {
    case MessageStatus.DeliverySucceeded:
    case MessageStatus.Read:
    case MessageStatus.Received:
    case MessageStatus.Sent:
      return true;
    default:
      return false;
  }
}

const fileSize = computed(() => {
  const i = Math.floor(Math.log(props.message.fileSize) / Math.log(1024));
  return `${Math.round(props.message.fileSize / 1024 ** i)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
});

function getMessageStyle() {
  let backgroundColour = '#f5f5f5';
  let textColour = '#212121';

  if (props.message.direction === 'outbound') {
    backgroundColour = props.outboundMessageColour;
    textColour = tinycolor2(backgroundColour).isDark() ? '#fff' : '#212121';
  }

  if (props.message.status === MessageStatus.DeliveryFailed) {
    backgroundColour = '#ffdada';
    textColour = '#212121';
  }

  return {
    background: backgroundColour,
    color: textColour,
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-file-message", {
      'n-file-message--left': __props.tooltipPosition === 'right',
      'n-file-message--right': __props.tooltipPosition === 'left',
    }])
  }, [
    (__props.displayAvatar)
      ? (_openBlock(), _createBlock(NAvatar, {
          key: 0,
          size: "s",
          name: __props.message.name,
          imageUrl: __props.message.avatarUrl,
          enableTooltip: __props.enableAvatarTooltip,
          class: _normalizeClass(["n-file-message__avatar", {
        'n-file-message__avatar--left': __props.tooltipPosition === 'right',
        'n-file-message__avatar--right': __props.tooltipPosition === 'left',
      }])
        }, null, 8, ["name", "imageUrl", "enableTooltip", "class"]))
      : _createCommentVNode("", true),
    _createVNode(NTooltip, { position: __props.tooltipPosition }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "n-file-message__message-container",
          style: _normalizeStyle(getMessageStyle())
        }, [
          _createVNode(NIcon, { icon: "file" }),
          _createElementVNode("a", {
            href: __props.message.mediaSrc,
            download: "",
            style: _normalizeStyle({ color: getMessageStyle().color })
          }, [
            _createTextVNode(_toDisplayString(__props.message.fileName) + " ", 1),
            _createElementVNode("span", _hoisted_2, "(" + _toDisplayString(fileSize.value) + ")", 1)
          ], 12, _hoisted_1)
        ], 4)
      ]),
      message: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(getMessageTimestamp(__props.message.timestampUtc)) + " ", 1),
          (shouldShowAlertIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 0,
                icon: "alert",
                fill: "#ff6348"
              }))
            : _createCommentVNode("", true),
          (shouldShowTickIcon(__props.message))
            ? (_openBlock(), _createBlock(NIcon, {
                key: 1,
                icon: "tick",
                fill: isRead(__props.message) ? '#57d272' : '#bdbdbd'
              }, null, 8, ["fill"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["position"])
  ], 2))
}
}

})